import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { partyFileHref } from './callContact.js';
import './partyLink.css';

/**
 * A customer's (or lead's) name or number that opens their file. Use it for
 * every place the CRM module shows a party, so a click always lands on the
 * same file. Inside a clickable row/card pass `inRow` so the click opens the
 * file and does not also trigger the row's own action.
 */
export function PartyLink({
  base,
  partyRef,
  kind = 'customer',
  inRow = false,
  children,
}: {
  readonly base: string;
  readonly partyRef: string | null | undefined;
  readonly kind?: 'customer' | 'lead';
  readonly inRow?: boolean;
  readonly children: ReactNode;
}) {
  const ref = partyRef?.trim();
  if (!ref) return <>{children}</>;
  return (
    <Link
      to={partyFileHref(kind, ref, base)}
      className="crm-party-link"
      onClick={inRow ? (event) => event.stopPropagation() : undefined}
      onKeyDown={inRow ? (event) => event.stopPropagation() : undefined}
    >
      {children}
    </Link>
  );
}
